import { LuBell, LuMessageCircle, LuMessageSquare, LuMegaphone } from 'react-icons/lu';
import { FiAlertTriangle } from 'react-icons/fi';
import { formatDistanceToNow } from 'date-fns';

export default function NotificationItem({ notification, onClick }) {
  const getIcon = () => {
    switch (notification.type) {
      case 'mention':
        return <LuMessageCircle className="w-5 h-5 text-blue-600" />;
      case 'fault_new':
      case 'fault_status':
        return <FiAlertTriangle className="w-5 h-5 text-orange-600" />;
      case 'topic_new':
      case 'topic_reply':
        return <LuMessageSquare className="w-5 h-5 text-purple-600" />;
      case 'announcement':
        return <LuMegaphone className="w-5 h-5 text-green-600" />;
      default:
        return <LuBell className="w-5 h-5 text-gray-600" />;
    }
  };

  return (
    <button
      onClick={onClick}
      className={`w-full text-left p-3 hover:bg-gray-50 transition border-b border-gray-100 last:border-b-0 ${
      !notification.is_read ? 'bg-blue-50' : ''}`
      }>

      <div className="flex gap-3">
        <div className="flex-shrink-0 mt-1">
          {getIcon()}
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-medium text-sm text-gray-900 truncate">
            {notification.title}
          </p>
          <p className="text-sm text-gray-600 line-clamp-2">{notification.message}</p>
          <p className="text-xs text-gray-500 mt-1">
            {formatDistanceToNow(new Date(notification.created_at), { addSuffix: true })}
          </p>
        </div>
        {!notification.is_read &&
        <div className="flex-shrink-0">
            <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
          </div>
        }
      </div>
    </button>);

}